import { ProcessFilterGroups } from '@components/GalleryComponents/GalleryPageContent/GalleryPageContent';
import { FilterGroups } from '@components/GalleryComponents/GalleryPageContent/GalleryPageContentFiltering';
import { useCallback } from 'react';

const WEDDING_WEBSITE_PRODUCT_TYPE = 'Wedding Website';

const _getTemplateImageUrl = (filename: string, version: string = '1638397480'): string =>
  `https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/new-websites/${filename}.jpg?v=${version}`;

const _deriveDesignTemplateId = (themeId: string, photoPresentationLayout: PhotoPresentationLayout): string =>
  `${themeId}-${photoPresentationLayout}`;
//For tags, refer to `eCardCategorySlugsToTagsMap` in `src/utils/gallery.util.ts`

export const WEBSITE_TEMPLATE_GALLERY_CARDS: ReadonlyArray<GalleryECard> = [
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('charlotte-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Blue', 'White'],
    font: 'EB Garamond',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    title: 'Charlotte',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    designThemeId: _deriveDesignTemplateId('charlotte', 'fullWidth'),
    websiteSettings: {
      colors: {
        artBackground: '#5D8EC6',
        pageBackground: '#5D8EC6',
        pageFont: '#FFFFFF',
        linkAndButton: '#FFFFFF',
        artFont: '#FFFFFF',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'EB Garamond',
    },
    theme: {
      name: 'Charlotte',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('coastal-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Gray', 'Green'],
    font: 'WindSong',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('coastal', 'fullWidth'),
    title: 'Coastal',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#E6ECEC',
        pageBackground: '#E6ECEC',
        pageFont: '#4D6A69',
        linkAndButton: '#4D6A69',
        artFont: '#4D6A69',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'WindSong',
    },
    theme: {
      name: 'Coastal',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('editorial_lime-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Green', 'Dark Green'],
    font: 'Cinzel',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('editorial_lime', 'fullWidth'),
    title: 'Editorial Lime',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#C9E265',
        pageBackground: '#C9E265',
        pageFont: '#25520B',
        linkAndButton: '#25520B',
        artFont: '#25520B',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'Cinzel',
    },
    theme: {
      name: 'Editorial Lime',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('emilio_mocha-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Brown', 'White'],
    font: 'Forum',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('emilio_mocha', 'fullWidth'),
    title: 'Emilio Mocha',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#A47764',
        pageBackground: '#A47764',
        pageFont: '#FFFFFF',
        linkAndButton: '#FFFFFF',
        artFont: '#FFFFFF',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'Forum',
    },
    theme: {
      name: 'Emilio Mocha',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('gala_black-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Black', 'White'],
    font: 'Homemade Apple',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('gala_black', 'fullWidth'),
    title: 'Gala Black',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#FBF3F0',
        pageBackground: '#FBF3F0',
        pageFont: '#000000',
        linkAndButton: '#000000',
        artFont: '#000000',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'Homemade Apple',
    },
    theme: {
      name: 'Gala Black',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('magazine_indigo-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Navy', 'Pink'],
    font: 'Viaoda Libre',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('magazine_indigo', 'fullWidth'),
    title: 'Magazine Indigo',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#242E6B',
        pageBackground: '#242E6B',
        pageFont: '#DFA0AE',
        linkAndButton: '#DFA0AE',
        artFont: '#DFA0AE',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'Viaoda Libre',
    },
    theme: {
      name: 'Magazine Indigo',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('minimalist_arch-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Green', 'Beige'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('minimalist_arch', 'fullWidth'),
    title: 'Minimalist Arch',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#6A725B',
        pageBackground: '#6A725B',
        pageFont: '#FBE7C1',
        linkAndButton: '#FBE7C1',
        artFont: '#FBE7C1',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'DM Serif Display',
    },
    theme: {
      name: 'Minimalist Arch',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('modern_arch-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Pink', 'Black'],
    font: 'Viaoda Libre',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('modern_arch', 'fullWidth'),
    title: 'Modern Arch',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#EDE0DB',
        pageBackground: '#EDE0DB',
        pageFont: '#000000',
        linkAndButton: '#000000',
        artFont: '#000000',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'Viaoda Libre',
    },
    theme: {
      name: 'Modern Arch',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('modern_lines_light-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Green', 'White'],
    font: 'WindSong',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('modern_lines_light', 'fullWidth'),
    title: 'Modern Lines Light',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#69847F',
        pageBackground: '#69847F',
        pageFont: '#FFFFFF',
        linkAndButton: '#FFFFFF',
        artFont: '#FFFFFF',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'WingSong',
    },
    theme: {
      name: 'Modern Lines Light',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('newsstand_olive-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Green', 'Pink'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('newsstand_olive', 'fullWidth'),
    title: 'Newsstand Olive',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#5F7200',
        pageBackground: '#5F7200',
        pageFont: '#FFC4D1',
        linkAndButton: '#FFC4D1',
        artFont: '#FFC4D1',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'DM Serif Display',
    },
    theme: {
      name: 'Newsstand Olive',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('newsstand_taffy-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Blue', 'Pink'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('newsstand_taffy', 'fullWidth'),
    title: 'Newsstand Taffy',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#006772',
        pageBackground: '#006772',
        pageFont: '#F9CFD8',
        linkAndButton: '#F9CFD8',
        artFont: '#F9CFD8',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'DM Serif Display',
    },
    theme: {
      name: 'Newsstand Taffy',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('queens_palace-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Navy', 'Gold'],
    font: 'Herr Von Muellerhoff',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('queens_palace', 'fullWidth'),
    title: 'Queens Palace',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#101D3D',
        pageBackground: '#101D3D',
        pageFont: '#D9C891',
        linkAndButton: '#D9C891',
        artFont: '#D9C891',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'Herr Von Muellerhoff',
    },
    theme: {
      name: 'Queens Palace',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('regal_garden-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Beige', 'Black'],
    font: 'Pinyon Script',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('regal_garden', 'fullWidth'),
    title: 'Regal Garden',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#F6F3ED',
        pageBackground: '#F6F3ED',
        pageFont: '#000000',
        linkAndButton: '#000000',
        artFont: '#000000',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'Pinyon Script',
    },
    theme: {
      name: 'Regal Garden',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('rose_bed-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Black', 'Pink'],
    font: 'Gilda Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('rose_bed', 'fullWidth'),
    title: 'Rosebed',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#000000',
        pageBackground: '#000000',
        pageFont: '#91787E',
        linkAndButton: '#91787E',
        artFont: '#91787E',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'Gilda Display',
    },
    theme: {
      name: 'Rosebed',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('rustic_chic-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Beige', 'Brown'],
    font: 'EB Garamond',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('rustic_chic', 'fullWidth'),
    title: 'Rustic Chic',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#FCFBF7',
        pageBackground: '#FCFBF7',
        pageFont: '#82716D',
        linkAndButton: '#82716D',
        artFont: '#82716D',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'EB Garamond',
    },
    theme: {
      name: 'Rustic Chic',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('sun_arch_iii-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Red', 'White'],
    font: 'Meddon',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('sun_arch_iii', 'fullWidth'),
    title: 'Sun Arch III',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#953C2E',
        pageBackground: '#953C2E',
        pageFont: '#FFFFFF',
        linkAndButton: '#FFFFFF',
        artFont: '#FFFFFF',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'Meddon',
    },
    theme: {
      name: 'Sun Arch III',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('tiffany_lilac-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Purple', 'Pink'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('tiffany_lilac', 'fullWidth'),
    title: 'Tiffany Lilac',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#C8D4FC',
        pageBackground: '#C8D4FC',
        pageFont: '#DF217A',
        linkAndButton: '#DF217A',
        artFont: '#DF217A',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'DM Serif Display',
    },
    theme: {
      name: 'Tiffany Lilac',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('tiffany_red_ii-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['White', 'Red'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('tiffany_red_ii', 'fullWidth'),
    title: 'Tiffany Red II',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#FFFFFF',
        pageBackground: '#FFFFFF',
        pageFont: '#EB4848',
        linkAndButton: '#EB4848',
        artFont: '#EB4848',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'DM Serif Display',
    },
    theme: {
      name: 'Tiffany Red II',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('tiffany_red-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Red', 'White'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('tiffany_red', 'fullWidth'),
    title: 'Tiffany Red',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#EB4848',
        pageBackground: '#EB4848',
        pageFont: '#FFFFFF',
        linkAndButton: '#FFFFFF',
        artFont: '#FFFFFF',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'DM Serif Display',
    },
    theme: {
      name: 'Tiffany Red',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('wavy_pink-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Pink', 'Red'],
    font: 'Seaweed Script',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('wavy_pink', 'fullWidth'),
    title: 'Wavy Pink',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colors: {
        artBackground: '#F9DEEC',
        pageBackground: '#F9DEEC',
        pageFont: '#E45751',
        linkAndButton: '#E45751',
        artFont: '#E45751',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
      fontPackName: 'Seaweed Script',
    },
    theme: {
      name: 'Wavy Pink',
      themeId: 'blank',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('nelson_duo_right'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Green', 'Yellow'],
    font: 'Ultra',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('nelson', 'photoDuoRight'),
    title: 'Nelson',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Nelson',
      themeId: 'blank',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#22AD70',
        pageBackground: '#22AD70',
        pageFont: '#FCF7D7',
        linkAndButton: '#FCF7D7',
        artFont: '#FCF7D7',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Ultra',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('minimalist_arch_mocha_arch'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern'],
    colors: ['Brown', 'Beige'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'blank',
    designThemeId: _deriveDesignTemplateId('minimalist_arch_mocha', 'photoArch'),
    title: 'Minimalist Arch Mocha',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Minimalist Arch Mocha',
      themeId: 'blank',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#A17E65',
        pageBackground: '#A17E65',
        pageFont: '#E7DFD0',
        linkAndButton: '#E7DFD0',
        artFont: '#E7DFD0',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'DM Serif Display',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('magazine_trio'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Pink', 'Red'],
    font: 'Viaoda Libre',
    variantColor: null,
    variantName: null,
    variantThemeId: 'magazine_trio',
    designThemeId: _deriveDesignTemplateId('magazine', 'photoTrio'),
    title: 'Magazine',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Magazine',
      themeId: 'blank',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#F9CFD8',
        pageBackground: '#F9CFD8',
        pageFont: '#EF5205',
        linkAndButton: '#EF5205',
        artFont: '#EF5205',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Viaoda Libre',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('brannan-lydia-photoBackground'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Classic'],
    colors: ['White'],
    font: 'Abril Fatface',
    variantColor: null,
    variantName: null,
    variantThemeId: 'lydia_photobackground',
    designThemeId: _deriveDesignTemplateId('lydia', 'photoBackground'),
    title: 'Lydia',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Lydia',
      themeId: 'blank',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#FFFFFF',
        pageBackground: '#FFFFFF',
        pageFont: '#333333',
        linkAndButton: '#6C6C6C',
        artFont: '#333333',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Abril Fatface',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('brannan-chloe-photoBackground'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Floral & Botanical'],
    colors: ['Green', 'Beige'],
    font: 'Cormorant',
    variantColor: null,
    variantName: null,
    variantThemeId: 'chloe_photobackground',
    designThemeId: _deriveDesignTemplateId('chloe', 'photoBackground'),
    title: 'Chloe',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Chloe',
      themeId: 'blank',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#919478',
        pageBackground: '#919478',
        pageFont: '#FFFFFF',
        linkAndButton: '#E5ECD1',
        artFont: '#FFFFFF',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Cormorant',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('pomona_marquee'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Yellow', 'Orange', 'Beige'],
    font: 'Bungee',
    variantColor: null,
    variantName: null,
    variantThemeId: 'pomona_marquee',
    designThemeId: _deriveDesignTemplateId('pomona', 'photoMarquee'),
    title: 'Pomona',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Pomona',
      themeId: 'blank',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#FCF7D7',
        pageBackground: '#FCF7D7',
        pageFont: '#FC6248',
        linkAndButton: '#FC6248',
        artFont: '#FC6248',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Bungee',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('brannan-rosebed-photoBackground'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Floral & Botanical'],
    colors: ['Black', 'White'],
    font: 'Cormorant',
    variantColor: null,
    variantName: null,
    variantThemeId: 'rosebed_photobackground',
    designThemeId: _deriveDesignTemplateId('rosebed', 'photoBackground'),
    title: 'Rose Bed',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Rose Bed',
      themeId: 'blank',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#131313',
        pageBackground: '#131313',
        pageFont: '#FFFFFF',
        linkAndButton: '#B59CA7',
        artFont: '#FFFFFF',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Cormorant',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('brannan-tourmaline-photoBackground'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Pink', 'Red', 'Purple'],
    font: 'Text Me One',
    variantColor: null,
    variantName: null,
    variantThemeId: 'tourmaline_photobackground',
    designThemeId: _deriveDesignTemplateId('tourmaline', 'photoBackground'),
    title: 'Tourmaline',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Tourmaline',
      themeId: 'tourmaline',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#E75850',
        pageBackground: '#E75850',
        pageFont: '#FFFFFF',
        linkAndButton: '#E75850',
        artFont: '#FFFFFF',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Text Me One',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('felicity_olive_mono'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern'],
    colors: ['Green'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'felicity_olive',
    designThemeId: _deriveDesignTemplateId('felicity_olive', 'monogram'),
    title: 'Felicity Olive',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Felicity Olive',
      themeId: 'felicity_olive',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#6A725B',
        pageBackground: '#6A725B',
        pageFont: '#FFFFFF',
        linkAndButton: '#FFFFFF',
        artFont: '#FFFFFF',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Gilda Display',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('classical_crest_navy_mono'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Classic'],
    colors: ['Blue'],
    font: 'Cinzel',
    variantColor: null,
    variantName: null,
    variantThemeId: 'classical_crest_navy_mono',
    designThemeId: _deriveDesignTemplateId('classical_crest_navy', 'monogram'),
    title: 'Classical Crest Navy',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Classical Crest Navy',
      themeId: 'classical_crest_navy_mono',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#273559',
        pageBackground: '#273559',
        pageFont: '#FFE9A3',
        linkAndButton: '#FFE9A3',
        artFont: '#FFE9A3',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Cinzel',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('quince_fullphoto'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Yellow', 'Green'],
    font: 'Coiny',
    variantColor: null,
    variantName: null,
    variantThemeId: 'quince_fullphoto',
    designThemeId: _deriveDesignTemplateId('quince', 'fullWidth'),
    title: 'Quince',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Quince',
      themeId: 'quince_fullphoto',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#FADC50',
        pageBackground: '#FADC50',
        pageFont: '#1E8450',
        linkAndButton: '#1E8450',
        artFont: '#1E8450',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Coiny',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('brannan-stone_and_gold-photoBackground'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Textured', 'Metallic'],
    colors: ['Gold', 'Grey'],
    font: 'Cormorant',
    variantColor: null,
    variantName: null,
    variantThemeId: 'stone_and_gold_photobackground',
    designThemeId: _deriveDesignTemplateId('stone_and_gold', 'photoBackground'),
    title: 'Stone & Gold',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Stone & Gold',
      themeId: 'stone_and_gold_photobackground',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#F3F5F3',
        pageBackground: '#F3F5F3',
        pageFont: '#6C6C6C',
        linkAndButton: '#333333',
        artFont: '#6C6C6C',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Cormorant',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('stamp_papaya_mono'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Classic', 'Bold'],
    colors: ['Orange'],
    font: 'Jost',
    variantColor: null,
    variantName: null,
    variantThemeId: 'stamp_papaya',
    designThemeId: _deriveDesignTemplateId('stamp_papaya', 'monogram'),
    title: 'Stamp Papaya',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Stamp Papaya',
      themeId: 'stamp_papaya',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#D16C50',
        pageBackground: '#D16C50',
        pageFont: '#FFFFFF',
        linkAndButton: '#FFFFFF',
        artFont: '#FFFFFF',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Jost',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('brannan-mountain_getaway-photoBackground'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Rustic', 'Destination', 'Seasonal'],
    colors: ['Blue', 'Green', 'Brown'],
    font: 'Calistoga',
    variantColor: null,
    variantName: null,
    variantThemeId: 'mountain_getaway',
    designThemeId: _deriveDesignTemplateId('mountain_getaway', 'photoBackground'),
    title: 'Mountain Getaway',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Mountain Getaway',
      themeId: 'mountain_getaway',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#A89173',
        pageBackground: '#A89173',
        pageFont: '#FFFFFF',
        linkAndButton: '#F6F0D9',
        artFont: '#FFFFFF',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Calistoga',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('mulberry_slider'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Classic'],
    colors: ['Purple'],
    font: 'Mrs Saint Delafield',
    variantColor: null,
    variantName: null,
    variantThemeId: 'mulberry',
    designThemeId: _deriveDesignTemplateId('mulberry', 'photoSlider'),
    title: 'Mulberry',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Mulberry',
      themeId: 'mulberry',
      marketingData: [],
    },
    websiteSettings: {
      colors: {
        artBackground: '#785168',
        pageBackground: '#785168',
        pageFont: '#FFFFFF',
        linkAndButton: '#FFFFFF',
        artFont: '#FFFFFF',
      },
      pageTransparency: false,
      pageShadow: false,
      isBlankTemplate: true,
      fontPackName: 'Mrs Saint Delafield',
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
];

const NEW_TEMPLATE_THEME_IDS = new Set(WEBSITE_TEMPLATE_GALLERY_CARDS.map((card) => card.theme.themeId));

function insertEveryNth(initialCards: MarketingData, cardsToInsert: MarketingData, interval: number, randomize?: boolean): MarketingData {
  const copiedCards = [...initialCards];
  const cards = randomize ? copiedCards.sort(() => Math.random() - 0.5) : copiedCards;
  let cardToInsertIndex = 0;
  let cardToInsert: GalleryECard | undefined = undefined;
  for (let i = 0; i < initialCards.length + Math.floor(initialCards.length / interval); i += interval) {
    cardToInsert = cardsToInsert[cardToInsertIndex++];
    if (!cardToInsert) {
      return cards;
    }
    cards.splice(i, 0, cardToInsert);
  }
  return cards;
}

export const insertNewTemplates = (initialCards: MarketingData): MarketingData => {
  return insertEveryNth(initialCards, [...WEBSITE_TEMPLATE_GALLERY_CARDS], 4, true);
};

export const processDesignFilterGroups: ProcessFilterGroups = (filterGroups, { hasFiltersApplied }): FilterGroups => {
  const { matchesWithNewTemplates, matchesWithoutNewTemplates } = filterGroups.match.reduce(
    (acc, card) => {
      acc[
        NEW_TEMPLATE_THEME_IDS.has(card.theme.themeId) && card.isComingSoon ? 'matchesWithNewTemplates' : 'matchesWithoutNewTemplates'
      ].push(card);
      return acc;
    },
    { matchesWithoutNewTemplates: [], matchesWithNewTemplates: [] } as {
      matchesWithoutNewTemplates: MarketingData;
      matchesWithNewTemplates: MarketingData;
    }
  );
  /**
   * When viewing save the date or invitation cards, prioritize joy printed themes
   */
  return {
    match: hasFiltersApplied
      ? insertEveryNth(matchesWithoutNewTemplates, matchesWithNewTemplates, 5, false)
      : insertEveryNth(filterGroups.match, [...WEBSITE_TEMPLATE_GALLERY_CARDS], 5, false),
    noMatch: filterGroups.noMatch,
  };
};
